import { render, staticRenderFns } from "./Consumers.vue?vue&type=template&id=3a2432b7"
import script from "./Consumers.vue?vue&type=script&lang=js"
export * from "./Consumers.vue?vue&type=script&lang=js"
import style0 from "./Consumers.vue?vue&type=style&index=0&id=3a2432b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports